<template>
  <div class="empty-tip">
    <span>拖拽</span>
    <span class="high-text">「 左侧标签 」</span>
    <span>到</span>
    <span class="high-text">「 标签栏 」</span>
    <span>和</span>
    <span class="high-text">「 统计栏 」</span>
    <span>，拖拽后图表会自动显示</span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.empty-tip {
  min-height: 150px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #77839e;

  .high-text {
    color: #2c3443;
  }
}
</style>
